import { Box, Typography } from "@material-ui/core";
import { CloseOutlined } from "@material-ui/icons";
import { LinkedIn, Twitter } from "@mui/icons-material";
import { styled } from "@mui/material";
import React from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";

import { primary } from "../../../constants/theme";

const CustomDescriptionOffCanvas = styled(Box)(({ theme }) => ({
  ".details": {
    padding: "32px",
    ".image-close": {
      display: "flex",
      justifyContent: "space-between",
      img: {
        width: "200px",
        height: "200px",
        borderRadius: "15px",
      },
      ".close": {
        color: primary.main,
        cursor: "pointer",
        marginTop: "unset",
        marginRight: "unset",
      },
    },
    ".name": {
      fontSize: "32px",
      lineHeight: "160%",
      fontWeight: "700",
    },
    ".designation": {
      fontSize: "24px",
      lineHeight: "160%",
      fontWeight: "700",
      color: primary.main,
    },
    ".description": {
      fontSize: "20px",
      lineHeight: "160%",
      fontWeight: "500",
      marginTop: "24px",
    },
    svg: {
      color: primary.main,
      marginTop: "24px",
      marginRight: "10px",
    },
  },
  [theme.breakpoints.down("md")]: {
    ".details": {
      padding: "24px 16px",
      ".image-close": {
        img: {
          width: "100px",
          height: "100px",
          borderRadius: "15px",
        },
      },
      ".name": {
        fontSize: "10px",
        lineHeight: "16px",
      },
      ".designation": {
        fontSize: "8px",
        lineHeight: "12px",
      },
      ".description": {
        fontSize: "6px",
        lineHeight: "10px",
        marginTop: "8px",
      },
    },
  },
}));

const DescriptionOffCanvas = ({ details, handleClick }) => {
  return (
    <CustomDescriptionOffCanvas>
      <Box className="details">
        <Box className="image-close">
          <LazyLoadImage
            src={details?.profile_img}
            alt={details?.name}
            effect="opacity"
          />
          <CloseOutlined
            onClick={() => {
              handleClick();
            }}
            className="close"
          />
        </Box>
        <Typography className="name">{details?.name}</Typography>
        <Typography className="designation">{details?.designation}</Typography>
        <Typography className="description">{details?.description}</Typography>
        <Twitter />
        <LinkedIn />
      </Box>
    </CustomDescriptionOffCanvas>
  );
};
export default DescriptionOffCanvas;
